import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { PaymentProvider } from '../models/payment-provider';
import { GiftCard } from '../../giftcard/models/giftcard';
import { DiscountCoupon } from '../models/discount-coupon';
import { PrepaidPaymentInfo } from '../models/prepaid-payment-info';


@Injectable()
export class PaymentService {

  // Create transaction and get payment form
  paymentTransaction(orderId: number, paymentProviderId: number): Observable<string> {
    return of();
  }

  paymentGuestTransaction(orderId: number, guestOrderKey: string, paymentProviderId: number): Observable<string> {
    return of();
  }

  payOrderByGiftCard(orderId: number): Observable<boolean> {
    return of();
  }

  guestPayOrderByGiftCard(orderId: number): Observable<string> {
    return of();
  }

  payOrderByCash(orderId: number): Observable<boolean> {
    return of();
  }

  getPaymentProviders(): Observable<PaymentProvider[]> {
    return of();
  }

  prepaidOrder(orderNumber: number, giftCardRedeems: GiftCard[], discountCoupon: DiscountCoupon[]): Observable<PrepaidPaymentInfo> {
    return of();
  }

  prepaidGuestOrder(orderNumber: number, giftCardRedeems: GiftCard[], discountCoupon: DiscountCoupon[]): Observable<PrepaidPaymentInfo> {
    return of();
  }
}
